import { z } from 'zod';

/**
 * Wire shapes and react-query keys for the lead-scanner rep-mapping routes
 * (`GET`/`PUT /mappings`, `GET /sfdc-users`). Zod-only on purpose: the route
 * handlers in `api.ts` build their responses against these same schemas
 * (`satisfies z.input<...>`), and the client half lives in
 * `rep-mapping-client.ts`.
 */

/** React-query key for `GET /mappings`, shared by Home and the mapper screen. */
export const MAPPINGS_QUERY_KEY = ['lead-scanner', 'mappings'] as const;

/** React-query key for `GET /sfdc-users`, shared by scan-review and the mapper screen. */
export const SFDC_USERS_QUERY_KEY = ['lead-scanner', 'sfdc-users'] as const;

export const MappingsResponseSchema = z.object({
  mappings: z.array(z.object({ email: z.string(), campaignId: z.string() }).passthrough()),
});

export const SfdcUsersResponseSchema = z.object({
  users: z.array(z.object({ name: z.string(), email: z.string(), role: z.string().nullable() })),
});

/**
 * The `PUT /mappings` success body (followups §11.8): the route's own
 * `{ok: true, added, removed}`.
 */
export const MappingsSaveResponseSchema = z.object({
  ok: z.literal(true),
  added: z.number(),
  removed: z.number(),
});

export type Rep = z.infer<typeof SfdcUsersResponseSchema>['users'][number];
